import { NgModule } from '@angular/core';
import { ArquiteturaModule } from 'src/app/arquitetura/arquitetura.module';
import { PlanosPage } from './planos.page';

@NgModule({
  declarations: [
    PlanosPage
  ],
  imports: [
    ArquiteturaModule
  ]
})
export class PlanosModule { }
